import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function DogTrainingAuthority() {
  return (
    <section className="section relative" data-testid="dog-training-authority">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-14">
          <div className="md:col-span-4">
            <div className="text-eyebrow text-gold">01 / The Core Practice</div>
            <div className="hairline-gold mt-4 w-16" />
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-[clamp(2.4rem,6vw,6rem)] leading-[0.95] tracking-[-0.02em]">
              Dog training is where the <span className="italic gold-foil">mission began.</span>
            </h2>
            <p className="mt-6 max-w-2xl text-bone/75 text-lg font-editorial leading-relaxed">
              For more than two decades, Toriano Sanzone has studied leadership through the relationship between humans and dogs. As a third-generation Master Dog Trainer and founder of <em className="text-gold">Wolfkeeper University</em>, he has trained more than 4,000 dogs, developed professional trainers, managed advanced behavioral cases, and helped families build safer, healthier relationships with their dogs.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-12">
          {[
            "Phone Consultation",
            "In-Home Evaluation",
            "Private Dog Training",
            "Puppy Boot Camp",
            "Basic Obedience Boot Camp",
            "Behavioral Rehabilitation",
            "Service Dog Training",
            "Boarding & Training",
            "Train-the-Trainer Certification",
          ].map((s, i) => (
            <motion.div
              key={s}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              className="border border-hair hover:border-gold transition-colors p-5 bg-ink-2 flex items-center justify-between gap-3"
              data-testid={`service-preview-${i}`}
            >
              <div>
                <div className="text-hair text-gold mb-1">0{i + 1}</div>
                <div className="font-display text-xl">{s}</div>
              </div>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-bone/40"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
            </motion.div>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-between gap-6 border-t border-hair pt-10">
          <div>
            <div className="text-hair text-bone/50">Direct line</div>
            <a href="tel:3129331528" className="font-display text-4xl italic text-bone hover:text-gold" data-testid="authority-phone">312.933.1528</a>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/dog-training" className="btn-gold" data-testid="authority-cta-book">Book Dog Training</Link>
            <Link to="/dog-training#assessment" className="btn-outline" data-testid="authority-cta-assessment">Take the 3-min Assessment</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
